module.exports = __webpack_public_path__ + "static/media/lightbulb-slash.f0a5449f.svg";